<p-multiSelect
  #multiSelect
  [readonly]="isDisabledForEditing()"
  [formControl]="control()"
  [options]="options()"
  [placeholder]="placeholder()"
  [optionLabel]="optionLabel()"
  [optionValue]="optionValue()"
  [showClear]="showClear()"
  [selectionLimit]="selectionLimit()"
  [emptyFilterMessage]="emptyFilterMessage()"
  display="chip"
  [filter]="false"
  [appendTo]="appendTo()"
  (onFilter)="handleFilterChange($event)"
  [group]="group()"
  [maxSelectedLabels]="$maxSelectedLabels()"
  [class.pre-header]="$preHeaderTmpl()"
  [panelStyleClass]="$panelStyleClass()"
  [showToggleAll]="$showToggleAll()"
  [showHeader]="$showHeader()"
  [virtualScroll]="$virtualScroll()"
  [virtualScrollItemSize]="$virtualScrollItemSize()"
  [loading]="$loading()"
>
  <ng-template pTemplate="header">
    @if ($preHeaderTmpl(); as template) {
      <div class="preheader-anchor">
        <ng-container [ngTemplateOutlet]="template"></ng-container>
      </div>
    }
  </ng-template>

  <ng-template pTemplate="filter">
    @if (filter()) {
      <osp-select-panel-custom-header
        [filterInputAutoFocus]="$filterInputAutoFocus()"
        [filterValue]="multiSelect.filterValue"
        [selectAllValue]="$isAllSelected()"
        [filterDebounceTime]="$filterDebounceTime()"
        (onFilterInput)="multiSelect.onFilterInputChange(toKeyboardEvent($event))"
        (onSelectAll)="handleSelectAll($event)"
      />
    }
  </ng-template>

  <ng-template pTemplate="removetokenicon">
    <i [className]="IconKey.UISelectRemoveToken | icon"></i>
  </ng-template>

  <ng-template let-group pTemplate="group">
    @if ($groupTmpl(); as template) {
      <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{ group: group }"></ng-container>
    }
  </ng-template>

  @if (selectedItemsConfiguration(); as config) {
    <ng-template pTemplate="selectedItems" let-items>
      @if (isAllowedToSeeData()) {
        <osp-selected-items-template
          [items]="items || []"
          [title]="config.title"
          [selectedTitle]="config.selectedTitle"
          [placeholder]="placeholder() || ''"
          (mouseenter)="addTooltipClass()"
          (mouseleave)="removeTooltipClass()"
        ></osp-selected-items-template>
      } @else {
        <osp-selected-items-template
          [customTitle]="config.restrictedTitle || ''"
          [placeholder]="placeholder() || ''"
          (mouseenter)="addTooltipClass()"
          (mouseleave)="removeTooltipClass()"
        ></osp-selected-items-template>
      }
    </ng-template>
  }
</p-multiSelect>
